import React from 'react';
import {ProfilesContainer} from '../../Containers/PermissionControlsContainer';

export const Profiles = (props) => {
	return (
		<ProfilesContainer action="show" show=""/>
	);
}

export default Profiles;